
import styles from "./Loading.module.css";
function Loading(){
    return(
        <>
        <div className={styles.animationOuter}>
            <span></span>
        </div>
        </>
    );
}
export default Loading;